<template>
  <base-card>
    <router-link class="h6 font-weight-bold" :to="link">
      {{ investment.title }}
    </router-link>
    <p>
      <small class="no-text-overflow">{{ $formatting.stripTags(investment.intro) }}</small>
    </p>
    <div class="d-none d-sm-flex justify-content-sm-between text-center">
      <div>
        <small class="d-block">Return p.a.</small>
        <span class="font-weight-bold">{{ investment.funding.interestRate }}%</span>
      </div>
      <div>
        <small class="d-block">Loan to value</small>
        <span class="font-weight-bold">{{ investment.ltv }}%</span>
      </div>
      <div>
        <small class="d-block">Term remaining</small>
        <span class="font-weight-bold">{{ $investment.getRemainingTerm(investment) }}</span>
      </div>
      <div>
        <small class="d-block">Security</small>
        <span class="font-weight-bold">{{ $investment.getSecurityType(investment) }}</span>
      </div>
    </div>
    <div class="row d-sm-none text-center">
      <div class="col-6">
        <small class="d-block">Return p.a.</small>
        <span class="font-weight-bold">{{ investment.funding.interestRate }}%</span>
      </div>
      <div class="col-6">
        <small class="d-block">Loan to value</small>
        <span class="font-weight-bold">{{ investment.ltv }}%</span>
      </div>
      <div class="col-6 mt-2">
        <small class="d-block">Term remaining</small>
        <span class="font-weight-bold">{{ $investment.getRemainingTerm(investment) }}</span>
      </div>
      <div class="col-6 mt-2">
        <small class="d-block">Security</small>
        <span class="font-weight-bold">{{ $investment.getSecurityType(investment) }}</span>
      </div>
    </div>
    <div class="my-3">
      <p class="mb-1 text-center">
        <small>
          {{ $formatting.toCurrency($investment.getAvailableAmount(investment)) }}
          of {{ $formatting.toCurrency(investment.funding.funding) }} available
        </small>
      </p>
      <div class="progress">
        <div
          class="progress-bar bg-primary"
          role="progressbar"
          aria-valuemin="0"
          :aria-valuemax="investment.funding.funding"
          :aria-valuenow="investment.funding.funded"
          :style="progress"></div>
      </div>
    </div>
    <div class="text-center">
      <base-button secondary :to="link">
        Fund Loan
      </base-button>
    </div>
  </base-card>
</template>

<script>
export default {
  name: 'InvestmentCard',

  props: {
    investment: { required: true, type: Object }
  },

  computed: {
    link () {
      return {
        name: 'co-funding.opportunity',
        params: {
          id: this.investment._id
        }
      }
    },

    progress () {
      const progress = (this.investment.funding.funded / this.investment.funding.funding) * 100

      return {
        width: `${progress}%`
      }
    }
  }
}
</script>
